import styled from "styled-components";
import { Typography } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";
import {
  fadeIn,
  pressable,
  staggeredFadeInUp,
} from "../../utils/globalStyles/animations";
import Logo from "../../utils/globalStyles/logo/logo-02.png";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
`;

export const NewsCard = styled.div<{ $index: number }>`
  width: 100%;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  ${({ $index }) => staggeredFadeInUp($index, 70)}
  ${pressable}
`;

/* Banners são 2:1; o padding-top reserva o espaço antes da imagem carregar
   (evita a tela "pular") */
export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 50%;
  background-color: #ffffff;
`;

export const BannerImage = styled.img<{ $loaded: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
  transition: opacity 0.4s ease;
`;

export const ImageSkeleton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  & .MuiSkeleton-root {
    width: 100%;
    height: 100%;
    transform: none;
  }
`;

export const Placeholder = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url(${Logo});
  background-size: 35%;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.5;
`;

/* Fica no texto (e não sobre o banner) porque os banners costumam ter
   telefone/ID nos cantos */
export const CategoryBadge = styled.span`
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: rgba(192, 90, 33, 0.1);
  color: ${theme.colors.base};
  font-size: 11px;
  font-weight: 800;
`;

export const CardContent = styled.div`
  padding: 14px 16px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.04);
`;

export const TextGroup = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled(Typography)`
  font-size: 16px !important;
  font-weight: 800 !important;
  color: #333333;
  line-height: 1.25 !important;
`;

/* Prévia da descrição em até 2 linhas */
export const Description = styled(Typography)`
  font-size: 13px !important;
  color: #777777;
  line-height: 1.4 !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Arrow = styled.span`
  flex-shrink: 0;
  display: flex;
  color: ${theme.colors.base};
`;

export const SkeletonCard = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

export const Feedback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 16px;
  text-align: center;
  animation: ${fadeIn} 0.3s ease-out both;
`;

export const InfoText = styled(Typography)`
  color: #666;
  font-size: 15px !important;
`;

export const RetryButton = styled.button`
  border: 1px solid ${theme.colors.base};
  background: none;
  color: ${theme.colors.base};
  border-radius: 999px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
`;
